import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "../../features/videos/videosSlice";

export default function Pagination() {
  const [selectedPage, setSlectedPage] = useState(0);
  const videosPerPage = 4;
  const dispatch = useDispatch();
  const { noOfVideos } = useSelector((state) => state.videos);
  const totalNoOfPages = Math.ceil(noOfVideos / videosPerPage);
  const range = Array.from({ length: totalNoOfPages }, (_, i) => i + 1);
  const { tags, search, author } = useSelector((state) => state.filter);
  const handlePagination = (ind) => {
    setSlectedPage(ind);
    const start = videosPerPage * ind;
    dispatch(fetchVideos({ tags, search, author, start, limit: 4 }));
  };

  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {range.map((elm, index) => (
          <div
            className={
              selectedPage === index
                ? "bg-blue-600 text-white	px-4 py-1 rounded-full cursor-pointer"
                : "bg-blue-400 text-white px-4 py-1 rounded-full cursor-pointer"
            }
            onClick={() => handlePagination(index)}
          >
            {elm}
          </div>
        ))}
      </div>
    </section>
  );
}
